export const SCENE_TYPES = {
  AERIAL: 'AERIAL',
  LANDING: 'LANDING',
  GROUND: 'GROUND',
};

export const APARTMENT_SCENE_IDS = {
  studio: '68fa5dd33294b0149d46bb2a',
  '1pn': '68fadb0abeb5aead0ada1c6b',
  '2pn': '68fafb04e62230d4b4453c85',
  '3pn': '68faffe9e62230d4b44540ff',
};

export const AMENITIES_SCENE_IDS = {
  aerial: '68fb01aae62230d4b4455f1e',
  landing: '68fb0124e62230d4b4455c6c',
  ground: '68fb0083e62230d4b44559f3',
};

// '68fb02e7e62230d4b445441b',
// '68fb00d0e62230d4b44541ac',
// '68fb0120e62230d4b4454261',
// '68fb00b9e62230d4b445417f',
// '68fb02f3e62230d4b445443c',
// '68fb0303e62230d4b4454459',

export const isAerial = (type) =>
  String(type).toUpperCase() === SCENE_TYPES.AERIAL;

export default SCENE_TYPES;
